module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-detail-header"
  }, [_c('div', {
    staticClass: "header-icon"
  }, [_vm._t("icon")], 2), _vm._v(" "), _c('div', {
    staticClass: "header-content"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "header-btns"
  }, [_vm._t("btn")], 2), _vm._v(" "), (_vm.showBack) ? _c('rt-button', {
    staticClass: "rt-btn-back",
    attrs: {
      "icon-name": "rt-base-back"
    },
    on: {
      "click": _vm.back
    }
  }, [_vm._v(_vm._s(_vm.$tx('返回', 'xpc.detailheader.back')))]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33f750d1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/business/detail/rtDetailHeader.vue
// module id = 1479
// module chunks = 91